module.exports = __webpack_public_path__ + "static/card-2c3aa6feb7b58597bdcc15bd209b25e6.png";